module.exports = __webpack_public_path__ + "media/kuala lumpur/nyonya_food-4b2fc56e.jpg";